export function createSortByProp(prop) {
  return (a, b) => {
    let aProp = a[prop];
    let bProp = b[prop];

    if (!aProp && !bProp) {
      return 0;
    }

    if (!aProp) {
      return 1;
    }

    if (!bProp) {
      return -1;
    }

    aProp = aProp.toLowerCase();
    bProp = bProp.toLowerCase();

    if (aProp === bProp) {
      return 0;
    }

    return aProp < bProp ? -1 : 1;
  };
}

export function sortByField(arr, field, order = "ASC") {
  return [...arr].sort((a, b) => {
    const valueA = a[field];
    const valueB = b[field];

    if (typeof valueA === "number" && typeof valueB === "number") {
      if (order === "ASC") {
        return valueA < valueB ? -1 : 1;
      }
      return valueA < valueB ? 1 : -1;
    }

    if (typeof valueA === "string" && typeof valueB === "string") {
      if (order === "ASC") {
        return valueA.localeCompare(valueB);
      }
      return valueA.localeCompare(valueB) * -1;
    }

    return 0;
  });
}
